export default "__VITE_ASSET__XdRhpme2__"